module.exports = __webpack_public_path__ + "static/media/girlJumping.544ff0fe.webp";